import Upload from "@/partial/upload";

export default function UploadPage() {
  return <Upload />;
}
